'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var cloudEndpointTypes = {
    AWS: 'AWS',
    GCP: 'GCP',
    WASABI: 'WASABI',
    AZURE: 'AZURE'
};

var endpointTypes = _extends({
    SIGNIANT_DEVICES: 'SIGNIANT_DEVICES'
}, cloudEndpointTypes);

/**
 * @param {String} endpointType
 * @returns {boolean} - true if the endpointType is a cloudEndpointType
 */
var isCloudEndpointType = function isCloudEndpointType(endpointType) {
    return Object.values(cloudEndpointTypes).includes(endpointType);
};

module.exports = {
    endpointTypes: endpointTypes,
    cloudEndpointTypes: cloudEndpointTypes,
    isCloudEndpointType: isCloudEndpointType
};